import React from "react";
import { OFFICE_DETAILS } from "@utils/constants";

const OfficeAddress = () => {
  return (
    <div style={wrapper}>
      <h6 style={Textnormal}>{OFFICE_DETAILS.address}</h6>
      <h6 style={Textnormal}>{OFFICE_DETAILS.phoneNumber}</h6>
      <h6 style={Textnormal}>{OFFICE_DETAILS.HREmail}</h6>
      <h6 style={Textnormal}>{OFFICE_DETAILS.websiteURL}</h6>
    </div>
  );
};

const wrapper = {
  marginTop: "25px",
};

const Textnormal = {
  fontWeight: 100,
};

export default OfficeAddress;
